import { FormErrorBanner } from "@/components/Auth/shared";
import type { WaitlistViewProps } from "@/types/waitlist";

import { WaitlistAuthLinks } from "./WaitlistAuthLinks";
import { WaitlistFormActions } from "./WaitlistFormActions";
import { WaitlistProgress } from "./WaitlistProgress";
import { WaitlistStepContact } from "./WaitlistStepContact";
import { WaitlistStepProfessional } from "./WaitlistStepProfessional";
import { WaitlistStepSurvey } from "./WaitlistStepSurvey";

export type { WaitlistViewProps } from "@/types/waitlist";

export const WaitlistView = (props: WaitlistViewProps) => {
  const {
    step,
    survey,
    email,
    name,
    organizationName,
    isProfessional,
    specialtyId,
    contactPhone,
    specialties,
    isSubmitting,
    errors,
    onSurveyChange,
    onEmailChange,
    onNameChange,
    onOrganizationNameChange,
    onIsProfessionalChange,
    onSpecialtyIdChange,
    onContactPhoneChange,
    onNext,
    onBack,
    onSubmit,
  } = props;

  return (
    <div>
      <div className="mb-4">
        <h2 className="mb-2 text-3xl font-bold text-foreground">Join the waitlist</h2>
        <p className="text-muted-foreground">
          Tell us about you — we&apos;ll reach out when spots open.
        </p>
      </div>

      <WaitlistProgress step={step} />

      <form onSubmit={onSubmit}>
        <div>
          <WaitlistStepContact
            visible={step === 1}
            name={name}
            email={email}
            organizationName={organizationName}
            contactPhone={contactPhone}
            isSubmitting={isSubmitting}
            errors={errors}
            onNameChange={onNameChange}
            onEmailChange={onEmailChange}
            onOrganizationNameChange={onOrganizationNameChange}
            onContactPhoneChange={onContactPhoneChange}
          />

          <WaitlistStepSurvey
            visible={step === 2}
            survey={survey}
            errors={errors}
            onSurveyChange={onSurveyChange}
          />

          <WaitlistStepProfessional
            visible={step === 3}
            isProfessional={isProfessional}
            specialtyId={specialtyId}
            specialties={specialties}
            errors={errors}
            onIsProfessionalChange={onIsProfessionalChange}
            onSpecialtyIdChange={onSpecialtyIdChange}
          />
        </div>

        <FormErrorBanner message={errors.general} />

        <div className="mt-8 space-y-6">
          <WaitlistFormActions
            step={step}
            isSubmitting={isSubmitting}
            onBack={onBack}
            onNext={onNext}
          />
          <WaitlistAuthLinks />
        </div>
      </form>
    </div>
  );
};
